import React, { PureComponent } from 'react';

import { createContainer } from '@dbk-legacy/muster/react';
import BlurModal from '../../common/blur-modal';
import { PdfContent } from '../../../screens/modal-content';
import { EBANKINGWEBLUX, EBANKINGWEBUK, FSCS_LOGO_URL, RM_REGION_UK, RM_ACCESS, ROUTES, KEY_CODE } from '../../../../src/constants';
import  envConfig from '../../../../db-env-build';
import FSCSLogo from '../../../assets/svgs/Fscs-logo';
import Text from '@dbk/ui-text';
class AppFooter extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      doneVisible: true,
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.toggleModalDone = this.toggleModalDone.bind(this);
  }

  toggleModal(pageType) {
    this.setState({
      modal: !this.state.modal,
      modalContentType: pageType,
    });
  }

  toggleModalDone(displayModalDone) {
    this.setState({
      doneVisible: displayModalDone,
    });
  }


  modalContent() {
    const { modalContentType } = this.state;

    switch (modalContentType) {
      case 'faq':
        return <PdfContent modalContentType="faq" />;
      case 'security':
        return <PdfContent modalContentType="security" />;
      case 'userManual':
        return <PdfContent modalContentType="userManual" />;
      default:
        return <div />;
    }
  }

  render() {
    const { i18n: { messages }, changePage, languages: { destLanguage }, rmAccess: { userAdminGroup } } = this.props;
    let headerTitle = '';
    switch (this.state.modalContentType) {
      case 'faq': headerTitle = messages['app.login.faq'];
        break;
      case 'security': headerTitle = messages['app.login.securityTips'];
        break;
      case 'userManual': headerTitle = messages['app.login.userManual'];
        break;
      default: headerTitle = '';
        break;
    }
    let className = 'fscsText fscsLogo';
    if (destLanguage === "Deutsch") {
      className += ' fscsLogoGerman';
    }
    return (
      <div className="app-footer show-for-large ">
          <div className="columns">
            <Text
              tabIndex={0}
              id={messages['app.common.copyrightText']}
              className="copyright-text"
            >
              {' '}
              {messages['app.common.copyrightText']}{' '}
            </Text>
            <span className="pipe"> | </span>
            <Text
              tabIndex={0}
              secondary
              id={messages['app.common.copyrightDisclaimer']}
              className="copyright-disclaimer-text"
            >
              {' '}
              {messages['app.common.copyrightDisclaimer']}{' '}
            </Text>
          { (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) &&
            <div className={className} >
              <span className="pipe"> | </span>
              <span className='logoPosition'>
                <a rel="noopener" href={FSCS_LOGO_URL} target="_blank" aria-label={messages['app.login.accessibility.link.fscs'] + messages['app.payment.fscsLogo.text']} >
                  <FSCSLogo />
                  <Text secondary className='logoText'>{messages['app.payment.fscsLogo.text']}</Text>
                </a>
              </span>
            </div>
          }
            <div className="faq-security-tips">
              {/* WMCE-56387, WMCE-56437 - Commenting User manual guide */}
              {/* <div>
                <span className="pipe"> | </span>
                  <a tabIndex={0}
                    className="cursor nounderline"
                    id="User Manual"
                    href="javascript:;"
                    onClick={() => this.toggleModal('userManual')}
                  >
                  {messages['app.login.userManual']}
                  </a>
                </div> */}
              <span className="pipe"> | </span>
              <a tabIndex={0}
                className="cursor-pointer"
                id="FAQ"
                href="javascript:;"
                onClick={ userAdminGroup === RM_ACCESS.RM_DOC_UPLOAD ? () => this.props.changePage(ROUTES.RMACCESS.DOC_TAB_CONTAINER_FAQ) : () => this.props.changePage('/login-faq')}
              >
                 <Text className="link-style" secondary>{messages['app.login.faq']}</Text>
              </a>
              <span className="pipe"> | </span>
              <a tabIndex={0}
                className="cursor-pointer"
                id="SecurityTips"
                href="javascript:;"
                onClick={ userAdminGroup === RM_ACCESS.RM_DOC_UPLOAD ? () => this.props.changePage(ROUTES.RMACCESS.DOC_TAB_CONTAINER_SEQURITY) : () => this.props.changePage('/login-security')}
              >
                <Text className="link-style" secondary>{messages['app.login.securityTips']}</Text>
              </a>
            </div>
          </div>

        {this.state.modal &&
          <BlurModal
            onDone={this.toggleModal}
            visible={this.state.modal}
            headerChildren={headerTitle}
            doneVisible={this.state.doneVisible}
            size="large"
          >
            {this.modalContent()}
          </BlurModal>
        }
      </div>
    );
  }
}

export default createContainer(
  {
    $queries: {
      changePage: { $call: 'ui.history.push' },

      i18n: {
        messages: true,
      },
      languages: {
        destLanguage: true
      },
      rmAccess: {
        userAdminGroup: true
      }
    },
  },
  ({ ui, ...queries }) => ({
    ...queries,
  })
)(AppFooter);
